import Title from "../components/Title";
import Subtitle from "../components/Subtitle";
import Button from "../components/Button";
import BotMenu from "../assets/images/bot.png";
import BotCursor from "../assets/images/bot-cursor.png";
import Bang from "../components/Bang";

import decor1 from "../assets/images/decors/decor1.png";
import decor2 from "../assets/images/decors/decor2.png";
import decor3 from "../assets/images/decors/decor3.png";
import decor4 from "../assets/images/decors/decor4.png";
import decor5 from "../assets/images/decors/decor5.png";

const CompleteScreen = () => {
  return (
    <main className="relative z-10 bg-main flex items-center justify-center bg-cover bg-center min-h-screen w-full overflow-hidden">
      <div className="absolute z-[-1] -left-24 top-16 animate-moveX animate-moveY">
        <div className="absolute h-44 w-44 bg-blue opacity-10 blur-3xl rounded-full z-[-1] animate-pulse"></div>

        <img src={decor1} alt="Процент" />
      </div>
      <div className="absolute -z-10 -right-16 -bottom-8 animate-moveX animate-moveY">
        <div className="absolute h-44 w-44 right-1 bg-green opacity-5 blur-3xl rounded-full z-[-1] animate-pulse"></div>

        <img src={decor3} alt="Процент" />
      </div>
      <div className="absolute -z-10 left-24 top-112 animate-moveX animate-moveY">
        <img src={decor2} alt="Процент" />
      </div>
      <div className="absolute -z-10 -left-48 -bottom-20 animate-moveX animate-moveY">
        <img src={decor4} alt="Процент" />
      </div>
      <div className="absolute -z-10 -right-80 top-4 animate-moveX animate-moveY">
        <img src={decor5} alt="Процент" />
      </div>
      <div className="container mx-[5px] small:max-w-[500px] desktop:max-w-[912px] flex justify-center rounded-lg bg-gradient-dark-green border-darkGreen border-4">
        <section className="complete frame w-full">
          <div className="mobile:mb-6 desktop:mb-16">
            <Bang />
          </div>
          <div className="flex justify-center mobile:mb-3 desktop:mb-4">
            <Title text="Отлично!" />
          </div>
          <div className="flex justify-center mobile:mb-6 desktop:mb-12">
            <div className="max-w-[666px]">
              <Subtitle text="Ты успешно обменял приз на отрисовку. Заходи в бота во вкладку бонусы и используй её." />
            </div>
          </div>
          <div className="flex justify-center mobile:mb-12 small:mb-8 desktop:mb-8">
            <div className="absolute h-48 w-48 bg-green opacity-5 blur-3xl rounded-full z-[1]"></div>

            <div className="relative bot">
              <div className="img-decor"></div>
              <div className="w-[200px] h-[190px] relative">
                <img
                  className="z-[2] h-full w-full object-cover object-bottom"
                  src={BotMenu}
                  alt="Меню бота Дом Скамера"
                />
                <img
                  className="absolute z-[3] w-[94px] bottom-[26px] right-[0px] rotate-[-48deg]"
                  src={BotCursor}
                  alt="Курсор"
                />
              </div>
            </div>
          </div>
          <div className="flex justify-center mb-16 w-full">
            <Button text="Перейти" onClick={() => window.Telegram.WebApp.close()} />
          </div>
        </section>
      </div>
    </main>
  );
};

export default CompleteScreen;
